<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive>
        <router-view />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: "AppMain",
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key() {
      return this.$route.fullPath;
    },
  },
  methods: {
    isCached() {
      return this.cachedViews.indexOf(this.$route.name) !== -1;
    },
  },
};
</script>

<style scoped>
.app-main {
  background: #f3f3f4;
  height: calc(100vh - 64px);
  /* min-width: 1050px; */
  width: 100%;
  padding: 24px;
  position: relative;
  overflow-y: scroll;
}
</style>
